// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ddiC_","largestCol":"styles_largestCol__2Zhdq","smallestCol":"styles_smallestCol__rgkOx"};